import Star from '@mui/icons-material/Star';
import Translate from '@mui/icons-material/Translate';
import { Container } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { Outlet, useNavigate } from '@tanstack/react-router';
import { Navigation, Session } from '@toolpad/core/AppProvider';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import { FC, ReactNode, useEffect, useMemo, useState } from 'react';
import api from '../../app/api';
import { authStore } from '../../entity/auth/auth-store.js';
import { RouterAppProvider } from './router-app-provider';

const theme = createTheme({
    cssVariables: {
        colorSchemeSelector: 'data-toolpad-color-scheme',
    },
    colorSchemes: { light: true, dark: true },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
        },
    },
    components: {
        MuiContainer: {
            styleOverrides: {
                root: {
                    padding: 16,
                    minWidth: '100%',
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    height: '2.6rem',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    height: '2.6rem',
                    fontSize: '1rem',
                },
            },
        },
        // MuiAppBar: {
        //     styleOverrides: {
        //         root: {
        //             position: 'sticky',
        //             top: 0,
        //             zIndex: 1100,
        //         },
        //     },
        // },
    },
});

const NAVIGATION: Navigation = [
    {
        title: 'Translate',
        icon: <Translate />,
    },
    {
        segment: 'vocabulary',
        title: 'Vocabulary',
        icon: <Star />,
    },
];

export const MainLayout: FC<{ children: ReactNode }> = ({ children }) => {
    const { user } = authStore();
    const navigate = useNavigate();

    const [session, setSession] = useState<Session | null>(null);

    useEffect(() => {
        setSession({
            user: {
                name: user?.name,
                email: user?.email,
                image: user?.image,
            },
        });
    }, [user]);

    const authentication = useMemo(
        () => ({
            signIn: () => {
                setSession({
                    user: {
                        name: user?.name,
                        email: user?.email,
                        image: user?.image,
                    },
                });
            },
            signOut: async () => {
                await api.auth.logout();
                authStore.setState({ user: undefined });
                authStore.setState({ token: undefined });
                navigate({
                    to: '/',
                });
                setSession(null);
            },
        }),
        [],
    );

    return (
        <RouterAppProvider
            navigation={NAVIGATION}
            session={session}
            authentication={user ? authentication : null}
            theme={theme}
        >
            <DashboardLayout
                branding={{
                    logo: <img src="https://mui.com/static/logo.png" alt="Hello-hola logo" />,
                    title: 'Hello-Hola',
                    homeUrl: '/',
                }}
            >
                <Container
                    sx={{
                        flex: '100dvh',
                        minWidth: '60%',
                        width: {
                            xs: '100%',
                            sm: '100%',
                            md: '90%',
                            lg: '70%',
                            xl: '60%',
                        },
                    }}
                >
                    {children}
                    <Outlet />
                </Container>
            </DashboardLayout>
        </RouterAppProvider>
    );
};
